import { CameraSaveClipDto, useCameraApi } from "~/api/GeneratedApi";
import { useCustomMutation } from "~/utils/hooks/useCustomMutation";
import { useCustomQuery } from "~/utils/hooks/useCustomQuery";

export const useCameraClips = ({ cameraId }: { cameraId: number }) => {
  const { getClips, saveClip } = useCameraApi();

  const { data: cameraClips } = useCustomQuery(
    { key: "get-camera-clips", id: cameraId },
    () => getClips(cameraId),
  );

  const { mutateAsync: saveCamClipAsync, isLoading: clipCreationLoading } =
    useCustomMutation(
      ({ camId, clipInfo }: { camId: number; clipInfo: CameraSaveClipDto }) =>
        saveClip(camId, { ...clipInfo }),
    );

  return { cameraClips, saveCamClipAsync, clipCreationLoading };
};
